import React from "react";
import { Dialog, JSONViewer } from "../../../ui";
import { TraceAgentsView } from "./TraceAgentsView";

interface SubTraceModalProps {
  subTrace: Record<string, any> | null;
  evaluatorName: string | null;
  onClose: () => void;
}

export function SubTraceModal({
  subTrace,
  evaluatorName,
  onClose,
}: SubTraceModalProps) {
  if (!subTrace) return null;

  return (
    <Dialog
      title="Evaluation Sub-Trace"
      subtitle={evaluatorName}
      onClose={onClose}
      ariaLabelledBy="sub-trace-modal-title"
    >
      <TraceAgentsView traceData={subTrace} />
      {!subTrace.trace?.agent_instance_by_id && !subTrace.agents && (
        <JSONViewer data={subTrace} />
      )}
    </Dialog>
  );
}
